module.exports = __webpack_public_path__ + "static/img/990907294497ee3e64c19368a7d1ea3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_05.png
// module id = xI+f
// module chunks = 1